import React, { useState, useEffect } from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
import { Input } from "../../../revvComponents";
import { RevvForm } from "../../../commonComponents";

import {
  MetaFieldInitialValuesMap,
  MetaFieldComponentRules,
  MetaFieldComponentMessages,
  TransformMetaFieldValue,
} from "./MetaFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../actions";

const {
  toggleDynamicFieldView,
  // setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
} = DocumentTemplateActions;

const MetaFieldNumber = props => {
  const [numberFieldValues, getDataForPrepopulateData] = useState([]);
  const [showDefaultValue] = useState(true);
  const getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(MetaFieldInitialValuesMap.NUMBER),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = propsData.meta;
    }
    getDataForPrepopulateData(returnData);
  };
  useEffect(() => {
    props.setFlagForDefault(true);
    getDataForPrepopulate(props);
  }, [props]);

  return (
    <React.Fragment>
      {/* <Input
        id="checkbox"
        type="checkbox"
        checked={showDefaultValue}
        data-test="NumberField-checkbox"
        onChange={() => toggleDefaultValue()}
        className="dynamicfieldcustom-footer-input errorborder"
      /> */}
      {/* <span className="dynamicfieldcustom-footer-checkboxinput">
        This has a default value
      </span> */}
      {showDefaultValue && (
        <RevvForm
          initialFormValue={numberFieldValues}
          customFieldName="NUMBER"
          transformFieldValue={TransformMetaFieldValue}
          validateOnChange
          customFieldComponentRules={MetaFieldComponentRules}
          customFieldComponentMessages={MetaFieldComponentMessages}
          render={formProps => {
            const {
              handleChange,
              handleBlur,
              messages,
              touched,
              errors,
              values,
              isValid,
            } = formProps;
            const allInAll = {
              isValid,
              messages,
              touched,
              errors,
              values,
            };
            console.debug("allInAll", allInAll);
            if (isValid) {
              // props.metaValidStatus(true);
              props.setMetaFieldValues(values);
            } else {
              // props.metaValidStatus(false);
              props.setMetaFieldValues({});
            }
            return (
              <React.Fragment>
                <div className="dynamicfieldcustom-revvform">
                  <span className="revvform-label">
                    Default value
                    {/* <span className="requiredwitherr-input"> *</span> */}
                  </span>
                  <Input
                    autoFocus
                    id="default"
                    name="default"
                    data-test="NumberField-default"
                    type="number"
                    value={values && values.default}
                    placeholder="Enter field default value"
                    className={`metafield-create-input ${
                      messages.default !== undefined &&
                      messages.default.required !== ""
                        ? "danger-border"
                        : ""
                    }`}
                    onChange={value => handleChange(value)}
                    onBlur={value => handleBlur(value)}
                    // required
                  />
                  {/* {messages.default && (
                    <ErrorMessages messages={messages.default.required} />
                  )} */}
                </div>
              </React.Fragment>
            );
          }}
        />
      )}
    </React.Fragment>
  );
  // }
};

const mapStateToProps = state => {
  const { meta } =
    state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  // setMetaFieldValues,
};

export default connect(mapStateToProps, mapDispatchToProps)(MetaFieldNumber);
